import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import StayTop from "../components/StayTop";
import { useNavigate, Link } from "react-router-dom";
import { useSendContactFormMutation } from '../slices/contactApiSlice';

const Contact = () => {
    const navigate = useNavigate();
    const [sendContactForm, { isLoading }] = useSendContactFormMutation();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        website: '' // honeypot - real users never see or fill this
    });
    const [formStatus, setFormStatus] = useState({ submitted: false, error: false, message: '' });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFormStatus({ submitted: false, error: false, message: '' });

        if (!formData.name || !formData.email || !formData.subject || !formData.message) {
            setFormStatus({
                submitted: false,
                error: true,
                message: 'Please fill in all required fields'
            });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setFormStatus({
                submitted: false,
                error: true,
                message: 'Please enter a valid email address'
            });
            return;
        }

        try {
            await sendContactForm(formData).unwrap();

            setFormStatus({
                submitted: true,
                error: false,
                message: 'Thank you for contacting us! We\'ll get back to you within 24 hours.'
            });

            setFormData({
                name: '',
                email: '',
                subject: '',
                message: '',
                website: ''
            });
        } catch (error) {
            setFormStatus({
                submitted: false,
                error: true,
                message: error?.data?.message || 'Something went wrong. Please email us at support@retrodayz.co.uk'
            });
        }
    };

    return (
        <>
            <style>{`
                .contact-form-wrapper {
                    background: white;
                    border-radius: 15px;
                    padding: 3rem;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.08);
                    border: 2px solid #f8f9fa;
                    margin-bottom: 2rem;
                }

                .contact-sidebar-card {
                    background: white;
                    border-radius: 15px;
                    padding: 2rem;
                    margin-bottom: 1.5rem;
                    box-shadow: 0 5px 15px rgba(0,0,0,0.08);
                    border: 2px solid #f8f9fa;
                    text-align: center;
                    transition: all 0.3s ease;
                }

                .contact-sidebar-card:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.12);
                    border-color: #FD7014;
                }

                .contact-form-wrapper .form-label {
                    color: #3E6D9C;
                    font-weight: 600;
                    margin-bottom: 0.5rem;
                    font-size: 0.95rem;
                }

                .contact-form-wrapper .form-control,
                .contact-form-wrapper .form-select {
                    border: 2px solid #e9ecef;
                    padding: 0.85rem 1rem;
                    border-radius: 8px;
                    font-size: 1rem;
                    transition: all 0.3s ease;
                }

                .contact-form-wrapper .form-control:focus,
                .contact-form-wrapper .form-select:focus {
                    border-color: #FD7014;
                    box-shadow: 0 0 0 0.2rem rgba(253, 112, 20, 0.15);
                    outline: none;
                }

                .contact-form-wrapper textarea.form-control {
                    resize: vertical;
                    min-height: 150px;
                }

                .submit-button {
                    background: #FD7014;
                    border: none;
                    color: white;
                    padding: 1rem 2.5rem;
                    border-radius: 50px;
                    font-weight: 700;
                    font-size: 1.1rem;
                    transition: all 0.3s ease;
                    width: 100%;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .submit-button:hover:not(:disabled) {
                    background: #e56312;
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px rgba(253, 112, 20, 0.4);
                }

                .submit-button:disabled {
                    background: #ccc;
                    cursor: not-allowed;
                    transform: none;
                }

                .sidebar-icon {
                    font-size: 3rem;
                    color: #FD7014;
                    margin-bottom: 1rem;
                }

                .sidebar-title {
                    color: #3E6D9C;
                    font-weight: 700;
                    font-size: 1.3rem;
                    margin-bottom: 0.75rem;
                }

                .sidebar-text {
                    color: #666;
                    font-size: 0.95rem;
                    line-height: 1.6;
                    margin-bottom: 1rem;
                }

                .email-button {
                    display: inline-block;
                    padding: 0.75rem 2rem;
                    background: #3E6D9C;
                    color: white;
                    border-radius: 50px;
                    text-decoration: none;
                    font-weight: 600;
                    transition: all 0.3s ease;
                    margin-top: 0.5rem;
                }

                .email-button:hover {
                    background: #2d5273;
                    color: white;
                    text-decoration: none;
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(62, 109, 156, 0.3);
                }

                @media (max-width: 991px) {
                    .contact-form-wrapper {
                        padding: 2rem;
                    }
                }

                @media (max-width: 768px) {
                    .contact-form-wrapper {
                        padding: 1.5rem;
                    }

                    .sidebar-icon {
                        font-size: 2.5rem;
                    }
                }
            `}</style>

            <StayTop />

            {/* Back Button */}
            <Container style={{marginTop: '2rem'}}>
                <Link className="btn btn-light orange-outline" onClick={() => navigate(-1)}>
                    ← Go Back
                </Link>
            </Container>

            {/* Header */}
            <Container style={{
                textAlign: 'center',
                marginTop: '3rem',
                marginBottom: '3rem'
            }}>
                <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>
                    📧
                </div>
                <h1 style={{
                    fontWeight: 'bold',
                    marginBottom: '1rem',
                    color: '#3E6D9C',
                    fontSize: '2.5rem'
                }}>
                    Get In Touch
                </h1>
                <p style={{
                    color: '#666',
                    fontSize: '1.15rem',
                    maxWidth: '700px',
                    margin: '0 auto',
                    lineHeight: '1.6'
                }}>
                    Have a question or need help? We're here for you! Send us a message and we'll respond within 24 hours.
                </p>
            </Container>

            <Container style={{marginBottom: '4rem'}}>
                <Row>
                    {/* Main Contact Form */}
                    <Col lg={8}>
                        <div className="contact-form-wrapper">
                            <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                                <FontAwesomeIcon
                                    icon={faPaperPlane}
                                    style={{fontSize: '2.5rem', color: '#FD7014', marginBottom: '1rem'}}
                                />
                                <h2 style={{
                                    color: '#3E6D9C',
                                    fontWeight: '700',
                                    fontSize: '1.8rem',
                                    marginBottom: '0.5rem'
                                }}>
                                    Send Us A Message
                                </h2>
                                <p style={{color: '#999', fontSize: '0.95rem'}}>
                                    Fill out the form below and we'll get back to you as soon as possible
                                </p>
                            </div>

                            {formStatus.submitted && (
                                <Alert
                                    variant="success"
                                    dismissible
                                    onClose={() => setFormStatus({ submitted: false, error: false, message: '' })}
                                    style={{borderRadius: '10px'}}
                                >
                                    <Alert.Heading>Message Sent!</Alert.Heading>
                                    <p style={{marginBottom: 0}}>{formStatus.message}</p>
                                </Alert>
                            )}

                            {formStatus.error && (
                                <Alert
                                    variant="danger"
                                    dismissible
                                    onClose={() => setFormStatus({ submitted: false, error: false, message: '' })}
                                    style={{borderRadius: '10px'}}
                                >
                                    <Alert.Heading>Oops!</Alert.Heading>
                                    <p style={{marginBottom: 0}}>{formStatus.message}</p>
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                {/* Honeypot field - hidden from sighted/keyboard users, bots tend to fill every field */}
                                <Form.Group
                                    style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}
                                    aria-hidden="true"
                                >
                                    <Form.Label htmlFor="website">Website</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="website"
                                        name="website"
                                        tabIndex="-1"
                                        autoComplete="off"
                                        value={formData.website}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Your Name *</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                placeholder="John Smith"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email Address *</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="john@example.com"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3">
                                    <Form.Label>What Can We Help You With? *</Form.Label>
                                    <Form.Select
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">-- Please Select --</option>
                                        <option value="General Inquiry">General Inquiry</option>
                                        <option value="Order Issue">Order Issue</option>
                                        <option value="Product Question">Product Question</option>
                                        <option value="Returns & Refunds">Returns & Refunds</option>
                                        <option value="Technical Support">Technical Support</option>
                                        <option value="Partnership/Business">Partnership/Business</option>
                                        <option value="Other">Other</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Your Message *</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={6}
                                        name="message"
                                        placeholder="Tell us how we can help you..."
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </Form.Group>

                                <Button
                                    type="submit"
                                    className="submit-button"
                                    disabled={isLoading}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Sending Message...
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faPaperPlane} style={{marginRight: '0.75rem'}} />
                                            Send Message
                                        </>
                                    )}
                                </Button>

                                <p style={{
                                    fontSize: '0.85rem',
                                    color: '#999',
                                    marginTop: '1rem',
                                    textAlign: 'center',
                                    marginBottom: 0
                                }}>
                                    * Required fields
                                </p>
                            </Form>
                        </div>
                    </Col>

                    {/* Sidebar - Email Only */}
                    <Col lg={4}>
                        <div className="contact-sidebar-card">
                            <FontAwesomeIcon icon={faEnvelope} className="sidebar-icon" />
                            <h3 className="sidebar-title">Email Support</h3>
                            <p className="sidebar-text">
                                Prefer to email us directly? We're always happy to help!
                            </p>
                            <a
                                href="mailto:support@retrodayz.co.uk"
                                className="email-button"
                            >
                                support@retrodayz.co.uk
                            </a>
                            <p style={{
                                fontSize: '0.85rem',
                                color: '#999',
                                marginTop: '1rem',
                                marginBottom: 0
                            }}>
                                Typical response time: 24 hours
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Contact;